/* Light-theme hero background — user-provided custom artwork.
   Subtle Ken Burns zoom (20s loop) gives a cinematic feel. */

const HERO_IMG_LIGHT =
  "https://customer-assets.emergentagent.com/job_pandemic-ready/artifacts/dcec608i_ChatGPT%20Image%20May%2016%2C%202026%2C%2004_36_08%20PM.png";

export default function UVHeroBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="uv-hero-bg-light" aria-hidden="true">
      <img
        src={HERO_IMG_LIGHT}
        alt=""
        className="absolute inset-0 w-full h-full object-cover hero-kenburns"
      />
    </div>
  );
}
